import api from '@/shared/api/api';

/* ── Direct-message conversations ── */

export const conversationApi = {
  /** List all conversations for the current user */
  list: () => api.get('/direct-messages/conversations').then((r: any) => r.data),

  /** Get a single conversation with its messages */
  get: (conversationId: any) => api.get(`/direct-messages/conversation/${conversationId}`).then((r: any) => r.data),

  /** Send a message inside a conversation */
  send: (conversationId: any, content: any) =>
    api.post(`/direct-messages/conversation/${conversationId}/send`, { content }).then((r: any) => r.data),

  /** Start or retrieve the admin support conversation */
  contactSupport: () => api.post('/direct-messages/contact-support').then((r: any) => r.data),

  /** Start a conversation linked to an annonce/professional */
  start: (data: any) => api.post('/direct-messages/start', data).then((r: any) => r.data),
};

/* ── Seller notification-style messages ── */

export const sellerMessageApi = {
  /** List paginated seller messages */
  list: (page = 1, limit = 20) => api.get(`/seller/messages?page=${page}&limit=${limit}`).then((r: any) => r.data),

  /** Mark a seller message as read */
  markAsRead: (messageId: any) => api.patch(`/seller/messages/${messageId}/read`).then((r: any) => r.data),
};

/* ── Client-to-admin support messages (/messages/*) ── */

export const supportMessageApi = {
  /** List support conversations */
  getConversations: () => api.get('/messages/conversations').then((r: any) => r.data),

  /** Get messages for a conversation */
  getMessages: (conversationId: any) => api.get(`/messages/conversation/${conversationId}`).then((r: any) => r.data),

  /** Send a new support message (creates a conversation) */
  send: (data: any) => api.post('/messages', data).then((r: any) => r.data),

  /** Reply to a support conversation */
  reply: (conversationId: any, content: any) =>
    api.post(`/messages/conversation/${conversationId}/reply`, { content }).then((r: any) => r.data),
};

/* ── Chatbot ── */

export const chatbotApi = {
  /** Send a chat message (or trigger welcome) */
  chat: (message: any, sessionId: any) =>
    api.post('/chatbot/chat', { message, session_id: sessionId }).then((r: any) => r.data),

  /** Start product Q&A mode */
  startProductQuestion: (data: any) => api.post('/chatbot/start-product-question', data).then((r: any) => r.data),

  /** Add product to existing chat session */
  addProductToSession: (data: any) => api.post('/chatbot/add-product-to-session', data).then((r: any) => r.data),

  /** Load chat history for a session */
  getHistory: (sessionId: any) => api.get(`/chatbot/history/${sessionId}`).then((r: any) => r.data),

  /** Clear chat history for a session */
  clearHistory: (sessionId: any) => api.delete(`/chatbot/history/${sessionId}`).then((r: any) => r.data),
};
